<template>
  <v-expansion-panel-text>
    <template v-slot:header>
      <h2 class="heading_two">
        <v-img
          alt="question icon"
          class="heading-icon"
          src="@/modules/policy/PolicyGuidanceCalculator/assets/question.svg"
        />Other Existing Coverage
      </h2>
    </template>
    <template v-slot:actions>
      <v-icon :icon="$vuetify.icons.expand" />
    </template>
    <v-col cols="12" pl-3 pr-3 mt-4>
      <h3 class="heading_three pl-3 pr-3 font-weight-medium">
        Do you or your spouse have any additional life insurance from other sources?
      </h3>
    </v-col>
    <v-col cols="12" pl-4 pr-4>
      <v-row mt-3 justify="space-around">
        <v-col cols="12" md="5">
          <OnexButton block color="secondary"> {{ $t('L_yes') }} </OnexButton>
        </v-col>
        <v-col cols="12" md="5">
          <OnexButton block color="primary"> {{ $t('L_no') }} </OnexButton>
        </v-col>
      </v-row>
    </v-col>
  </v-expansion-panel-text>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'OtherCoverage',
  components: {
    OnexButton,
  },
};

export default defineComponent(componentOptions);
</script>
